/**
 * @fileoverview "Your season so far ›" on Your Seasons, then "Your 2026 season ›" once the
 * season has ended: the way into the season review.
 *
 * There all season once the season has enough to show (the backend's
 * offeredReview: enough plants and enough days between its first entry and
 * its newest), and through the winter until the next season begins.
 * Otherwise nothing. The words are the brief's (offered.entry).
 *
 * Where: Your Seasons (SeasonPage), under the header.
 * API: none; the season offered comes with the season brief (GET /season,
 * useSeason).
 * Words (en/es): none of its own; the entry's title and hint are the brief's.
 *
 * @module SeasonReviewEntry
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Wheat } from 'lucide-react';
import type { SeasonOffered } from '@/shared/api/season';

/** What the entry shows. */
interface SeasonReviewEntryProps {
  /** The season offered (the brief's offered), or null for none. */
  offered: SeasonOffered | null;
}

/**
 * The entry to the season review, when there is a season to review.
 *
 * @param props.offered - The season offered, or null for none.
 */
export const SeasonReviewEntry: React.FC<SeasonReviewEntryProps> = ({ offered }) => {
  if (!offered) return null;
  return (
    <Link
      to={`/season/review?year=${offered.year}`}
      className="mt-3 flex min-h-11 items-center gap-3 rounded-lg border bg-card p-4 transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Wheat className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
      <span className="min-w-0 flex-1">
        <span className="block font-semibold font-body">{offered.entry.title.text}</span>
        <span className="block text-sm text-muted-foreground">{offered.entry.hint.text}</span>
      </span>
      <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground" aria-hidden="true" />
    </Link>
  );
};
